(() => {
  'use strict';

  const CONTRACT_VERSION = '2026-10-10-nl-be-language-38';
  const PUBLISHED_LANGUAGE_CODES = ['en', 'fr', 'nl'];

  // OFK_MARKET_MATRIX_START
  const MARKET_MATRIX = {
    "US":{"market":"us","defaultLocale":"en","contexts":[{"locale":"en","shopifyLocale":"en"}]},
    "GB":{"market":"uk","defaultLocale":"en-gb","contexts":[{"locale":"en-gb","shopifyLocale":"en"}]},
    "AU":{"market":"au","defaultLocale":"en-au","contexts":[{"locale":"en-au","shopifyLocale":"en"}]},
    "NZ":{"market":"nz","defaultLocale":"en-nz","contexts":[{"locale":"en-nz","shopifyLocale":"en"}]},
    "IE":{"market":"ie","defaultLocale":"en-ie","contexts":[{"locale":"en-ie","shopifyLocale":"en"}]},
    "SG":{"market":"sg","defaultLocale":"en-sg","contexts":[{"locale":"en-sg","shopifyLocale":"en"}]},
    "IN":{"market":"in","defaultLocale":"en-in","contexts":[{"locale":"en-in","shopifyLocale":"en"}]},
    "MY":{"market":"my","defaultLocale":"en-my","contexts":[{"locale":"en-my","shopifyLocale":"en"}]},
    "NL":{"market":"nl","defaultLocale":"en-nl","contexts":[{"locale":"en-nl","shopifyLocale":"en"},{"locale":"nl-nl","shopifyLocale":"nl"}]},
    "AT":{"market":"at","defaultLocale":"en-at","contexts":[{"locale":"en-at","shopifyLocale":"en"}]},
    "BE":{"market":"be","defaultLocale":"en-be","contexts":[{"locale":"en-be","shopifyLocale":"en"},{"locale":"nl-be","shopifyLocale":"nl"},{"locale":"fr-be","shopifyLocale":"fr"}]},
    "LU":{"market":"lu","defaultLocale":"en-lu","contexts":[{"locale":"en-lu","shopifyLocale":"en"}]},
    "NO":{"market":"no","defaultLocale":"en-no","contexts":[{"locale":"en-no","shopifyLocale":"en"}]},
    "SE":{"market":"se","defaultLocale":"en-se","contexts":[{"locale":"en-se","shopifyLocale":"en"}]},
    "FI":{"market":"fi","defaultLocale":"en-fi","contexts":[{"locale":"en-fi","shopifyLocale":"en"}]},
    "CH":{"market":"ch","defaultLocale":"en-ch","contexts":[{"locale":"en-ch","shopifyLocale":"en"}]},
    "PT":{"market":"pt","defaultLocale":"en-pt","contexts":[{"locale":"en-pt","shopifyLocale":"en"}]},
    "MT":{"market":"mt","defaultLocale":"en-mt","contexts":[{"locale":"en-mt","shopifyLocale":"en"}]},
    "EE":{"market":"ee","defaultLocale":"en-ee","contexts":[{"locale":"en-ee","shopifyLocale":"en"}]},
    "CA":{"market":"ca","defaultLocale":"en-ca","contexts":[{"locale":"en-ca","shopifyLocale":"en"}]},
    "MX":{"market":"mx","defaultLocale":"en-mx","contexts":[{"locale":"en-mx","shopifyLocale":"en"}]},
    "FR":{"market":"fr","defaultLocale":"en-fr","contexts":[{"locale":"en-fr","shopifyLocale":"en"},{"locale":"fr-fr","shopifyLocale":"fr"}]},
    "IT":{"market":"it","defaultLocale":"en-it","contexts":[{"locale":"en-it","shopifyLocale":"en"}]},
    "KR":{"market":"kr","defaultLocale":"en-kr","contexts":[{"locale":"en-kr","shopifyLocale":"en"}]},
    "TH":{"market":"th","defaultLocale":"en-th","contexts":[{"locale":"en-th","shopifyLocale":"en"}]},
    "VN":{"market":"vn","defaultLocale":"en-vn","contexts":[{"locale":"en-vn","shopifyLocale":"en"}]},
    "SA":{"market":"sa","defaultLocale":"en-sa","contexts":[{"locale":"en-sa","shopifyLocale":"en"}]},
    "KW":{"market":"kw","defaultLocale":"en-kw","contexts":[{"locale":"en-kw","shopifyLocale":"en"}]},
    "QA":{"market":"qa","defaultLocale":"en-qa","contexts":[{"locale":"en-qa","shopifyLocale":"en"}]},
    "BH":{"market":"bh","defaultLocale":"en-bh","contexts":[{"locale":"en-bh","shopifyLocale":"en"}]},
    "OM":{"market":"om","defaultLocale":"en-om","contexts":[{"locale":"en-om","shopifyLocale":"en"}]},
    "HK":{"market":"hk","defaultLocale":"en-hk","contexts":[{"locale":"en-hk","shopifyLocale":"en"}]},
    "MO":{"market":"mo","defaultLocale":"en-mo","contexts":[{"locale":"en-mo","shopifyLocale":"en"}]},
    "TW":{"market":"tw","defaultLocale":"en-tw","contexts":[{"locale":"en-tw","shopifyLocale":"en"}]}
  };
  // OFK_MARKET_MATRIX_END

  const normalizeCountry = (value) => String(value || '').trim().toUpperCase();
  const normalizeLocale = (value) => String(value || '').trim().toLowerCase().split('-')[0];

  const uniqueShopifyLocales = (market) =>
    [...new Set(market.contexts.map((context) => normalizeLocale(context.shopifyLocale)))];

  const defaultShopifyLocale = (market) => {
    const defaultContext = market.contexts.find((context) => context.locale === market.defaultLocale);
    return normalizeLocale(defaultContext?.shopifyLocale);
  };

  const validateMatrix = () => {
    const markets = Object.entries(MARKET_MATRIX);
    const contextCount = markets.reduce((total, [, market]) => total + market.contexts.length, 0);
    const marketIds = new Set();

    if (markets.length !== 34 || contextCount !== 38) return false;

    for (const [countryCode, market] of markets) {
      if (!/^[A-Z]{2}$/.test(countryCode) || !market.market || marketIds.has(market.market)) return false;
      marketIds.add(market.market);

      if (!market.contexts.some((context) => context.locale === market.defaultLocale)) return false;

      for (const context of market.contexts) {
        if (!PUBLISHED_LANGUAGE_CODES.includes(normalizeLocale(context.shopifyLocale))) return false;
      }
    }

    return true;
  };

  if (!validateMatrix()) {
    console.error('[OFK localization] The embedded 34-market / 38-published-context contract is invalid.');
    return;
  }

  if (customElements.get('ofk-market-language-selector')) return;

  customElements.define(
    'ofk-market-language-selector',
    class OfkMarketLanguageSelector extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.toggle = this.querySelector('.ofk-market-language-selector__toggle');
        this.panel = this.querySelector('.ofk-market-language-selector__panel');
        this.form = this.querySelector('form');
        this.countrySelect = this.querySelector('[data-ofk-country-select]');
        this.languageSelect = this.querySelector('[data-ofk-language-select]');
        this.submitButton = this.querySelector('[data-ofk-selector-submit]');
        this.status = this.querySelector('[data-ofk-selector-status]');
        this.closeControls = [...this.querySelectorAll('[data-ofk-selector-close]')];
        this.overlay = this.querySelector('.ofk-market-language-selector__overlay');

        if (
          !this.toggle ||
          !this.panel ||
          !this.form ||
          !this.countrySelect ||
          !this.languageSelect ||
          !this.submitButton ||
          !this.overlay
        ) {
          console.error('[OFK localization] Selector markup is incomplete.', this);
          return;
        }

        if (this.dataset.contractVersion !== CONTRACT_VERSION) {
          console.error('[OFK localization] Liquid and JavaScript contract versions do not match.', this);
          this.submitButton.disabled = true;
          return;
        }

        this.languageOptionTemplates = new Map(
          [...this.languageSelect.options].map((option) => [normalizeLocale(option.value), option.cloneNode(true)])
        );

        // Inert locale templates allow France to be selected from an English market.
        // French is never an active option for a non-French country.
        this.querySelectorAll('template[data-ofk-language-template]').forEach((template) => {
          const option = template.content.querySelector('option');
          if (option) this.languageOptionTemplates.set(normalizeLocale(option.value), option.cloneNode(true));
        });

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onLanguageChange = this.onLanguageChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);

        this.toggle.addEventListener('click', this.onToggleClick);
        this.countrySelect.addEventListener('change', this.onCountryChange);
        this.languageSelect.addEventListener('change', this.onLanguageChange);
        this.form.addEventListener('submit', this.onFormSubmit);
        this.closeControls.forEach((control) => control.addEventListener('click', this.onCloseClick));
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        document.addEventListener('keydown', this.onDocumentKeyDown);

        const requestedCountry = normalizeCountry(this.dataset.currentCountry);
        const fallbackCountry = this.countrySelect.querySelector('option[value="US"]')
          ? 'US'
          : normalizeCountry(this.countrySelect.options[0]?.value);
        const initialCountry = this.countrySelect.querySelector(`option[value="${requestedCountry}"]`)
          ? requestedCountry
          : fallbackCountry;

        this.countrySelect.value = initialCountry;
        this.syncLanguageOptions(initialCountry, normalizeLocale(this.dataset.currentLocale));
        this.initialCountry = this.countrySelect.value;
        this.initialLocale = this.languageSelect.value;
        this.updateSubmitState();

        const expectedMarkets = Number(this.dataset.expectedMarketCount);
        const expectedContexts = Number(this.dataset.expectedContextCount);
        const renderedMarkets = this.countrySelect.options.length;
        const matrixContexts = Object.values(MARKET_MATRIX).reduce(
          (total, market) => total + market.contexts.length,
          0
        );

        if (expectedMarkets !== 34 || expectedContexts !== 38 || matrixContexts !== 38) {
          console.error('[OFK localization] Selector count metadata does not match the contract.', this);
          this.submitButton.disabled = true;
          return;
        }

        if (renderedMarkets !== expectedMarkets) {
          console.warn(
            `[OFK localization] Shopify exposes ${renderedMarkets} of ${expectedMarkets} contracted markets.`,
            this
          );
        }

        this.initialized = true;
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.toggle.removeEventListener('click', this.onToggleClick);
        this.countrySelect.removeEventListener('change', this.onCountryChange);
        this.languageSelect.removeEventListener('change', this.onLanguageChange);
        this.form.removeEventListener('submit', this.onFormSubmit);
        this.closeControls.forEach((control) => control.removeEventListener('click', this.onCloseClick));
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
        this.initialized = false;
      }

      onToggleClick() {
        if (this.panel.hidden) {
          this.open();
        } else {
          this.close({ restoreFocus: true, reset: true });
        }
      }

      onCountryChange() {
        const countryCode = normalizeCountry(this.countrySelect.value);
        const market = MARKET_MATRIX[countryCode];
        if (!market) return;

        this.syncLanguageOptions(countryCode, defaultShopifyLocale(market));
        this.updateSubmitState();
      }

      onLanguageChange() {
        const market = MARKET_MATRIX[normalizeCountry(this.countrySelect.value)];
        if (!market) return;

        const allowedLocales = uniqueShopifyLocales(market);
        const selectedLocale = normalizeLocale(this.languageSelect.value);

        if (!allowedLocales.includes(selectedLocale)) {
          this.syncLanguageOptions(this.countrySelect.value, defaultShopifyLocale(market));
        }

        this.updateSubmitState();
      }

      onFormSubmit(event) {
        const countryCode = normalizeCountry(this.countrySelect.value);
        const localeCode = normalizeLocale(this.languageSelect.value);
        const market = MARKET_MATRIX[countryCode];

        if (!market || !uniqueShopifyLocales(market).includes(localeCode) || !this.languageOptionTemplates.has(localeCode)) {
          event.preventDefault();
          this.submitButton.disabled = true;
          return;
        }

        this.isSubmitting = true;
        this.submitButton.disabled = true;
      }

      onCloseClick() {
        this.close({ restoreFocus: true, reset: true });
      }

      onDocumentPointerDown(event) {
        if (this.panel.hidden || this.contains(event.target)) return;
        this.close({ restoreFocus: false, reset: true });
      }

      onDocumentKeyDown(event) {
        if (this.panel.hidden) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close({ restoreFocus: true, reset: true });
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = this.focusableElements();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      syncLanguageOptions(countryCode, preferredLocale) {
        const market = MARKET_MATRIX[normalizeCountry(countryCode)];
        if (!market) return;

        const allowedLocales = uniqueShopifyLocales(market);
        const availableLocales = allowedLocales.filter((localeCode) => this.languageOptionTemplates.has(localeCode));
        const fragment = document.createDocumentFragment();

        for (const localeCode of availableLocales) {
          fragment.append(this.languageOptionTemplates.get(localeCode).cloneNode(true));
        }

        this.languageSelect.replaceChildren(fragment);

        const defaultLocale = defaultShopifyLocale(market);
        const normalizedPreferred = normalizeLocale(preferredLocale);
        const nextLocale = availableLocales.includes(normalizedPreferred)
          ? normalizedPreferred
          : availableLocales.includes(defaultLocale)
            ? defaultLocale
            : availableLocales[0];

        if (nextLocale) {
          this.languageSelect.value = nextLocale;
          this.languageSelect.removeAttribute('aria-invalid');
          if (this.status) this.status.textContent = '';
        } else {
          this.languageSelect.setAttribute('aria-invalid', 'true');
          if (this.status) this.status.textContent = this.languageSelect.labels[0]?.textContent || '';
          console.error(`[OFK localization] No published language is available for ${countryCode}.`, this);
        }
      }

      updateSubmitState() {
        const market = MARKET_MATRIX[normalizeCountry(this.countrySelect.value)];
        const localeCode = normalizeLocale(this.languageSelect.value);
        const isValid = Boolean(market && uniqueShopifyLocales(market).includes(localeCode) && this.languageOptionTemplates.has(localeCode));
        const hasChanged =
          this.countrySelect.value !== this.initialCountry || this.languageSelect.value !== this.initialLocale;

        this.submitButton.disabled = !isValid || !hasChanged;
      }

      resetSelection() {
        this.countrySelect.value = this.initialCountry;
        this.syncLanguageOptions(this.initialCountry, this.initialLocale);
        this.updateSubmitState();
      }

      open() {
        this.resetSelection();
        this.panel.hidden = false;
        this.overlay.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('ofk-market-language-selector-open');
        window.requestAnimationFrame(() => this.countrySelect.focus());
      }

      close({ restoreFocus, reset }) {
        if (this.panel.hidden || this.isSubmitting) return;
        if (reset) this.resetSelection();
        this.panel.hidden = true;
        this.overlay.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('ofk-market-language-selector-open');
        if (restoreFocus) this.toggle.focus();
      }

      focusableElements() {
        return [...this.panel.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], [tabindex]')].filter(
          (element) => element.tabIndex >= 0 && !element.hidden
        );
      }
    }
  );
})();

